// extracted by mini-css-extract-plugin
export default {"layout":"layoutStyles_layout__bwbWL"};